<template>
    <div class="wrapper">
        <header class="header header--nb header--reg">
            <div class="header__container">
                <router-link class="header__logo" :to="{name: 'Home'}">
                    <img src="../../assets/img/logo.svg" width="150" height="52" alt="" />
                </router-link>
            </div>
        </header>
        <main class="page page--pt-very-big">
            <section class="register">
                <div class="register__container">
                    <div class="register__main">
                        <div class="register__col">

                            <div class="register__bonus" v-for="item in $store.state.promo_templates">
                                <span v-if="item.type == 1">{{ item.amount }}{{ $store.state.user.data.merchant.currency_sign }} {{ $store.state.translation.auth.registration.voucher }}</span>
                                <span v-if="item.type == 2">{{ item.freespins_number }} {{ $store.state.translation.auth.registration.freespins }}</span>
                                <span v-if="item.type == 3">{{ item.percent }}% {{ $store.state.translation.auth.registration.bonus }}</span>
                                {{ $sprintf($store.state.translation.auth.registration.bonus_from_to, item.deposit_index, item.min_deposit, $store.state.user.data.merchant.currency_sign) }}
                            </div>

                        </div>
                        <div class="register__col">
                            <form class="register__form form form--main" v-on:submit.prevent="submitForm">
                                <div class="form__title-bg">{{ $store.state.translation.auth.registration.register }}</div>
                                <div class="form__wrap">
                                    <label class="form__label">
                                        <span 
                                            class="form__input-wrap _before" 
                                            :class="{'_form-error': errors.email}">
                                            <input
                                                v-model="data.email"
                                                @input="errors.email = null, setUsername()"
                                                autocomplete="off" 
                                                type="text" 
                                                :placeholder="$store.state.translation.auth.registration.email" 
                                                class="input _email"/>
                                        </span>
                                    </label>

                                    <label class="form__label _mb">
                                        <span 
                                            class="form__input-wrap _before"
                                            :class="{'_form-error': errors.username}">
                                            <input 
                                                v-model="data.username"
                                                @input="errors.username = null"
                                                autocomplete="off" 
                                                type="text" 
                                                :placeholder="$store.state.translation.auth.registration.username" 
                                                class="input"/>
                                        </span>
                                    </label>

                                    <label class="form__label _mb">
                                        <span 
                                            class="form__input-wrap _before"
                                            :class="{'_form-error': errors.password}">
                                            <input 
                                                v-model="data.password"
                                                @input="errors.password = null"
                                                autocomplete="off" 
                                                type="password" 
                                                :placeholder="$store.state.translation.auth.registration.password" 
                                                class="input"/>
                                        </span>
                                    </label>

                                    <div class="form__row">
                                        <div class="select select_form register_currency_select" :class="{'currency_select_open': currency_select_open, '_form-error': errors.currency}">
                                            <v-select 
                                                v-model="data.currency"
                                                @change="changeMerchant"
                                                @input="errors.currency = null, changeMerchant()"
                                                :options="merchants"
                                                @open="currency_select_open = true"
                                                @close="currency_select_open = false"
                                                :placeholder="$store.state.translation.auth.registration.currency"
                                                label="name"
                                                class="filter">
                                                <template v-slot:no-options="{ search, searching }">
                                                  <template v-if="searching">
                                                     {{ $store.state.translation.default.select_not_found }}
                                                  </template>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div 
                                        class="checkbox"
                                        :class="{'_form-error': errors.agreement}">
                                        <input 
                                            v-model="data.agreement"
                                            @input="errors.agreement = null"
                                            id="c_1" 
                                            class="checkbox__input" 
                                            type="checkbox" 
                                            value="1" />
                                        <label for="c_1" class="checkbox__label">
                                            <span class="checkbox__text">{{ $store.state.translation.auth.registration.agreement }}</span>
                                        </label>
                                    </div>
                                </div>
                                <button type="submit" class="form__btn form-btn form-btn--big" :class="{'disabled-button': loader_button}">
                                    <loading-button />
                                    <span>{{ $store.state.translation.auth.registration.register_btn }}</span>
                                </button>

                                <div style="margin-top: -1rem;color: #535353;font-size: 10px;line-height: 15px; display: none;">
                                    This site is protected by reCAPTCHA and the Google 
                                    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                                    <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
                                </div>
                            </form>
                        </div>
                        <div class="register__women">
                            <picture>
                                <img src="../../assets/img/register.png" width="350" height="550" alt="" />
                            </picture>
                        </div>
                        <svg width="640" height="626" viewBox="0 0 640 626" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M277.298 92.9121C339.539 103.593 403.18 65.5718 459.534 94.0704C538.832 134.172 640.404 187.447 639.948 276.306C639.491 365.166 521.668 395.03 457.672 456.68C395.99 516.101 362.791 620.513 277.298 625.662C190.697 630.877 115.276 556.004 73.8075 479.797C40.0307 417.726 95.4476 346.489 87.1931 276.306C76.4075 184.603 -46.8928 82.6765 19.5606 18.5688C86.4584 -45.9675 185.684 77.1907 277.298 92.9121Z"
                                fill="#333333"
                            ></path>
                        </svg>
                        <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M84.6065 6.7861C82.7366 6.7861 81.213 5.26268 81.213 3.39304C81.213 1.5234 82.7366 0 84.6065 0C86.4764 0 88 1.5234 88 3.39304C88 5.26268 86.4879 6.7861 84.6065 6.7861ZM88 23.6936C88 21.824 86.4764 20.3006 84.6065 20.3006C82.7366 20.3006 81.213 21.824 81.213 23.6936C81.213 25.5633 82.7366 27.0867 84.6065 27.0867C86.4879 27.0867 88 25.5748 88 23.6936ZM88 43.9942C88 42.1246 86.4764 40.6012 84.6065 40.6012C82.7366 40.6012 81.213 42.1246 81.213 43.9942C81.213 45.8639 82.7366 47.3873 84.6065 47.3873C86.4879 47.3873 88 45.8754 88 43.9942ZM88 64.2948C88 62.4252 86.4764 60.9018 84.6065 60.9018C82.7366 60.9018 81.213 62.4252 81.213 64.2948C81.213 66.1645 82.7366 67.6879 84.6065 67.6879C86.4879 67.6994 88 66.176 88 64.2948ZM88 84.607C88 82.7373 86.4764 81.2139 84.6065 81.2139C82.7366 81.2139 81.213 82.7373 81.213 84.607C81.213 86.4766 82.7366 88 84.6065 88C86.4879 88 88 86.4766 88 84.607ZM67.6967 3.39304C67.6967 1.5234 66.1731 0 64.3033 0C62.4334 0 60.9098 1.5234 60.9098 3.39304C60.9098 5.26268 62.4334 6.7861 64.3033 6.7861C66.1847 6.7861 67.6967 5.26268 67.6967 3.39304ZM67.6967 23.6936C67.6967 21.824 66.1731 20.3006 64.3033 20.3006C62.4334 20.3006 60.9098 21.824 60.9098 23.6936C60.9098 25.5633 62.4334 27.0867 64.3033 27.0867C66.1847 27.0867 67.6967 25.5748 67.6967 23.6936ZM67.6967 43.9942C67.6967 42.1246 66.1731 40.6012 64.3033 40.6012C62.4334 40.6012 60.9098 42.1246 60.9098 43.9942C60.9098 45.8639 62.4334 47.3873 64.3033 47.3873C66.1847 47.3873 67.6967 45.8754 67.6967 43.9942ZM67.6967 64.2948C67.6967 62.4252 66.1731 60.9018 64.3033 60.9018C62.4334 60.9018 60.9098 62.4252 60.9098 64.2948C60.9098 66.1645 62.4334 67.6879 64.3033 67.6879C66.1847 67.6994 67.6967 66.176 67.6967 64.2948ZM67.6967 84.607C67.6967 82.7373 66.1731 81.2139 64.3033 81.2139C62.4334 81.2139 60.9098 82.7373 60.9098 84.607C60.9098 86.4766 62.4334 88 64.3033 88C66.1847 88 67.6967 86.4766 67.6967 84.607ZM47.3935 3.39304C47.3935 1.5234 45.8699 0 44 0C42.1301 0 40.6065 1.5234 40.6065 3.39304C40.6065 5.26268 42.1301 6.7861 44 6.7861C45.8699 6.7861 47.3935 5.26268 47.3935 3.39304ZM47.3935 23.6936C47.3935 21.824 45.8699 20.3006 44 20.3006C42.1301 20.3006 40.6065 21.824 40.6065 23.6936C40.6065 25.5633 42.1301 27.0867 44 27.0867C45.8699 27.0867 47.3935 25.5748 47.3935 23.6936ZM47.3935 43.9942C47.3935 42.1246 45.8699 40.6012 44 40.6012C42.1301 40.6012 40.6065 42.1246 40.6065 43.9942C40.6065 45.8639 42.1301 47.3873 44 47.3873C45.8699 47.3873 47.3935 45.8754 47.3935 43.9942ZM47.3935 64.2948C47.3935 62.4252 45.8699 60.9018 44 60.9018C42.1301 60.9018 40.6065 62.4252 40.6065 64.2948C40.6065 66.1645 42.1301 67.6879 44 67.6879C45.8699 67.6879 47.3935 66.176 47.3935 64.2948ZM47.3935 84.607C47.3935 82.7373 45.8699 81.2139 44 81.2139C42.1301 81.2139 40.6065 82.7373 40.6065 84.607C40.6065 86.4766 42.1301 88 44 88C45.8699 88 47.3935 86.4766 47.3935 84.607ZM27.0902 3.39304C27.0902 1.5234 25.5666 0 23.6967 0C21.8269 0 20.3033 1.5234 20.3033 3.39304C20.3033 5.26268 21.8269 6.7861 23.6967 6.7861C25.5666 6.7861 27.0902 5.26268 27.0902 3.39304ZM27.0902 23.6936C27.0902 21.824 25.5666 20.3006 23.6967 20.3006C21.8269 20.3006 20.3033 21.824 20.3033 23.6936C20.3033 25.5633 21.8269 27.0867 23.6967 27.0867C25.5666 27.0867 27.0902 25.5748 27.0902 23.6936ZM27.0902 43.9942C27.0902 42.1246 25.5666 40.6012 23.6967 40.6012C21.8269 40.6012 20.3033 42.1246 20.3033 43.9942C20.3033 45.8639 21.8269 47.3873 23.6967 47.3873C25.5666 47.3873 27.0902 45.8754 27.0902 43.9942ZM27.0902 64.2948C27.0902 62.4252 25.5666 60.9018 23.6967 60.9018C21.8269 60.9018 20.3033 62.4252 20.3033 64.2948C20.3033 66.1645 21.8269 67.6879 23.6967 67.6879C25.5666 67.6994 27.0902 66.176 27.0902 64.2948ZM27.0902 84.607C27.0902 82.7373 25.5666 81.2139 23.6967 81.2139C21.8269 81.2139 20.3033 82.7373 20.3033 84.607C20.3033 86.4766 21.8269 88 23.6967 88C25.5666 88 27.0902 86.4766 27.0902 84.607ZM6.78699 3.39304C6.78699 1.5234 5.26338 0 3.3935 0C1.52361 0 0 1.5234 0 3.39304C0 5.26268 1.52361 6.7861 3.3935 6.7861C5.26338 6.7861 6.78699 5.26268 6.78699 3.39304ZM6.78699 23.6936C6.78699 21.824 5.26338 20.3006 3.3935 20.3006C1.52361 20.3006 0 21.824 0 23.6936C0 25.5633 1.52361 27.0867 3.3935 27.0867C5.26338 27.0867 6.78699 25.5748 6.78699 23.6936ZM6.78699 43.9942C6.78699 42.1246 5.26338 40.6012 3.3935 40.6012C1.52361 40.6012 0 42.1246 0 43.9942C0 45.8639 1.52361 47.3873 3.3935 47.3873C5.26338 47.3873 6.78699 45.8754 6.78699 43.9942ZM6.78699 64.2948C6.78699 62.4252 5.26338 60.9018 3.3935 60.9018C1.52361 60.9018 0 62.4252 0 64.2948C0 66.1645 1.52361 67.6879 3.3935 67.6879C5.26338 67.6994 6.78699 66.176 6.78699 64.2948ZM6.78699 84.607C6.78699 82.7373 5.26338 81.2139 3.3935 81.2139C1.52361 81.2139 0 82.7373 0 84.607C0 86.4766 1.52361 88 3.3935 88C5.26338 88 6.78699 86.4766 6.78699 84.607Z"
                                fill="#FFC263"
                            ></path>
                        </svg>
                        <svg width="92" height="54" viewBox="0 0 92 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 52.45L52.44 1" stroke="#FBB848" stroke-width="2" stroke-miterlimit="10"></path>
                            <path d="M13.71 52.45L65.16 1" stroke="#FBB848" stroke-width="2" stroke-miterlimit="10"></path>
                            <path d="M26.4299 52.45L77.8699 1" stroke="#FBB848" stroke-width="2" stroke-miterlimit="10"></path>
                            <path d="M39.14 52.45L90.59 1" stroke="#FBB848" stroke-width="2" stroke-miterlimit="10"></path>
                        </svg>
                        <svg width="614" height="522" viewBox="0 0 614 522" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M314.564 48.3724C391.672 54.0876 476.644 7.50618 537.594 55.0816C601.553 105.006 623.786 198.353 608.888 278.111C595.637 349.055 523.232 385.217 467.39 430.937C420.087 469.665 375.275 511.895 314.564 519.081C245.91 527.208 174.877 514.92 120.699 471.976C60.1502 423.982 21.5211 354.593 10.5587 278.111C-2.35561 188.012 -16.7912 74.2499 55.8257 19.3728C127.804 -35.0216 224.591 41.7035 314.564 48.3724Z"
                                fill="#333333"
                            ></path>
                        </svg>
                        <picture class="register__main-plectr">
                            <source srcset="../../assets/img/register/01.svg" media="(min-width: 87.499em)" />
                            <img src="../../assets/img/transparent.png" width="150" height="276" alt="" />
                        </picture>
                        <picture class="register__main-plectr">
                            <source srcset="../../assets/img/register/02.svg" media="(min-width: 1023.98px)" />
                            <img src="../../assets/img/transparent.png" width="79" height="84" alt="" />
                        </picture>
                        <picture class="register__main-plectr">
                            <source srcset="../../assets/img/register/06.svg" media="(min-width: 1023.98px)" />
                            <img src="../../assets/img/transparent.png" width="602" height="619" alt="" />
                        </picture>
                        <picture class="register__main-plectr">
                            <source srcset="../../assets/img/register/07.svg" media="(min-width: 87.499em)" />
                            <img src="../../assets/img/transparent.png" width="105" height="105" alt="" />
                        </picture>
                        <picture class="register__main-plectr">
                            <source srcset="../../assets/img/register/08.svg" media="(min-width: 1023.98px)" />
                            <img src="../../assets/img/transparent.png" width="198" height="113" alt="" />
                        </picture>
                    </div>
                    <div class="register__steps steps">
                        <div class="steps__row">
                            <div class="steps__item">
                                <div class="steps__content">
                                    <div class="steps__step"><span>{{ $store.state.translation.auth.registration.step1 }}</span></div>
                                    <div class="steps__title">{{ $store.state.translation.auth.registration.step1_reg }}</div>
                                    <div class="steps__desc">
                                        {{ $store.state.translation.auth.registration.step1_reg_form }}
                                    </div>
                                    <svg width="281" height="72" viewBox="0 0 281 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M257.262 29.0759L233.35 5.27987L209.423 29.0759L185.51 5.27987L161.598 29.0759L140.507 8.08711L119.402 29.0759L95.4897 5.27987L71.5627 29.0759L47.6503 5.27987L23.7379 29.0759L0 5.45442L2.64724 2.80718L23.7379 23.796L47.6503 -5.54874e-05L71.5627 23.796L95.4897 -5.54874e-05L119.402 23.796L140.507 2.79263L161.598 23.796L185.51 -5.54874e-05L209.423 23.796L233.35 -5.54874e-05L257.262 23.796L278.367 2.80718L281 5.45442L257.262 29.0759Z"
                                            fill="#AF6B29"
                                        ></path>
                                        <path
                                            d="M257.262 71.6208L233.35 47.8248L209.423 71.6208L185.51 47.8248L161.598 71.6208L142.631 52.7411L142.616 47.4466L161.598 66.3409L185.51 42.5449L209.423 66.3409L233.35 42.5449L257.262 66.3409L278.367 45.3521L281 48.0139L257.262 71.6208Z"
                                            fill="#FF9D00"
                                        ></path>
                                    </svg>
                                </div>
                                <svg width="393" height="265" viewBox="0 0 393 265" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M31.7268 264L1.12311 1H391.877L361.273 264H31.7268Z" stroke="#FBB848" stroke-width="2"></path>
                                </svg>
                            </div>
                            <div class="steps__item">
                                <div class="steps__content">
                                    <div class="steps__step"><span>{{ $store.state.translation.auth.registration.step2 }}</span></div>
                                    <div class="steps__title">{{ $store.state.translation.auth.registration.step2_deposit }}</div>
                                    <div class="steps__desc" v-if="$store.state.promo_templates.length">
                                        {{ $sprintf($store.state.translation.auth.registration.step2_deposit_from, $store.state.promo_templates[0].min_deposit, $store.state.user.data.merchant.currency_sign) }}
                                    </div>
                                    <picture class="steps__plectr">
                                        <source srcset="../../assets/img/register/02.svg" media="(min-width: 1023.98px)" />
                                        <img src="../../assets/img/transparent.png" width="79" height="84" alt="" />
                                    </picture>
                                </div>
                                <svg width="393" height="265" viewBox="0 0 393 265" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M31.7268 264L1.12311 1H391.877L361.273 264H31.7268Z" stroke="#FBB848" stroke-width="2"></path>
                                </svg>
                            </div>
                            <div class="steps__item">
                                <div class="steps__content">
                                    <div class="steps__step"><span>{{ $store.state.translation.auth.registration.step3 }}</span></div>
                                    <div class="steps__title">{{ $store.state.translation.auth.registration.step3_gift }}</div>
                                    <div class="steps__desc">
                                        {{ $store.state.translation.auth.registration.step3_get_bonus }}
                                    </div>
                                </div>
                                <svg width="393" height="265" viewBox="0 0 393 265" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M31.7268 264L1.12311 1H391.877L361.273 264H31.7268Z" stroke="#FBB848" stroke-width="2"></path>
                                </svg>
                            </div>
                        </div>
                        <svg width="613" height="626" viewBox="0 0 613 626" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M309.622 502.564C232.514 496.849 149.572 665.012 88.6219 617.437C24.6625 567.512 -10.8292 323.583 4.06842 243.826C17.3197 172.881 89.7245 136.719 145.567 90.9999C192.87 52.2718 237.682 10.0416 298.392 2.85498C367.046 -5.27191 438.08 7.01638 492.257 49.9603C552.806 97.9545 591.435 167.344 602.398 243.826C615.312 333.925 629.748 447.687 557.131 502.564C485.152 556.958 399.595 509.233 309.622 502.564Z"
                                fill="#333333"
                            ></path>
                        </svg>

                        <picture class="steps__plectr">
                            <source srcset="../../assets/img/register/02.svg" media="(min-width: 1023.98px)" />
                            <img src="../../assets/img/transparent.png" width="71" height="76" alt="" />
                        </picture>

                        <picture class="steps__plectr">
                            <source srcset="../../assets/img/register/03.svg" media="(min-width: 74.999em)" />
                            <img src="../../assets/img/transparent.png" width="612" height="625" alt="" />
                        </picture>
                        <picture class="steps__plectr">
                            <source srcset="../../assets/img/register/04.svg" media="(min-width: 1023.98px)" />
                            <img src="../../assets/img/transparent.png" width="602" height="619" alt="" />
                        </picture>

                        <picture class="steps__plectr">
                            <source srcset="../../assets/img/register/05.svg" media="(min-width: 1023.98px)" />
                            <img src="../../assets/img/transparent.png" width="79" height="84" alt="" />
                        </picture>
                        <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M84.6065 6.7861C82.7366 6.7861 81.213 5.26268 81.213 3.39304C81.213 1.5234 82.7366 0 84.6065 0C86.4764 0 88 1.5234 88 3.39304C88 5.26268 86.4879 6.7861 84.6065 6.7861ZM88 23.6936C88 21.824 86.4764 20.3006 84.6065 20.3006C82.7366 20.3006 81.213 21.824 81.213 23.6936C81.213 25.5633 82.7366 27.0867 84.6065 27.0867C86.4879 27.0867 88 25.5748 88 23.6936ZM88 43.9942C88 42.1246 86.4764 40.6012 84.6065 40.6012C82.7366 40.6012 81.213 42.1246 81.213 43.9942C81.213 45.8639 82.7366 47.3873 84.6065 47.3873C86.4879 47.3873 88 45.8754 88 43.9942ZM88 64.2948C88 62.4252 86.4764 60.9018 84.6065 60.9018C82.7366 60.9018 81.213 62.4252 81.213 64.2948C81.213 66.1645 82.7366 67.6879 84.6065 67.6879C86.4879 67.6994 88 66.176 88 64.2948ZM88 84.607C88 82.7373 86.4764 81.2139 84.6065 81.2139C82.7366 81.2139 81.213 82.7373 81.213 84.607C81.213 86.4766 82.7366 88 84.6065 88C86.4879 88 88 86.4766 88 84.607ZM67.6967 3.39304C67.6967 1.5234 66.1731 0 64.3033 0C62.4334 0 60.9098 1.5234 60.9098 3.39304C60.9098 5.26268 62.4334 6.7861 64.3033 6.7861C66.1847 6.7861 67.6967 5.26268 67.6967 3.39304ZM67.6967 23.6936C67.6967 21.824 66.1731 20.3006 64.3033 20.3006C62.4334 20.3006 60.9098 21.824 60.9098 23.6936C60.9098 25.5633 62.4334 27.0867 64.3033 27.0867C66.1847 27.0867 67.6967 25.5748 67.6967 23.6936ZM67.6967 43.9942C67.6967 42.1246 66.1731 40.6012 64.3033 40.6012C62.4334 40.6012 60.9098 42.1246 60.9098 43.9942C60.9098 45.8639 62.4334 47.3873 64.3033 47.3873C66.1847 47.3873 67.6967 45.8754 67.6967 43.9942ZM67.6967 64.2948C67.6967 62.4252 66.1731 60.9018 64.3033 60.9018C62.4334 60.9018 60.9098 62.4252 60.9098 64.2948C60.9098 66.1645 62.4334 67.6879 64.3033 67.6879C66.1847 67.6994 67.6967 66.176 67.6967 64.2948ZM67.6967 84.607C67.6967 82.7373 66.1731 81.2139 64.3033 81.2139C62.4334 81.2139 60.9098 82.7373 60.9098 84.607C60.9098 86.4766 62.4334 88 64.3033 88C66.1847 88 67.6967 86.4766 67.6967 84.607ZM47.3935 3.39304C47.3935 1.5234 45.8699 0 44 0C42.1301 0 40.6065 1.5234 40.6065 3.39304C40.6065 5.26268 42.1301 6.7861 44 6.7861C45.8699 6.7861 47.3935 5.26268 47.3935 3.39304ZM47.3935 23.6936C47.3935 21.824 45.8699 20.3006 44 20.3006C42.1301 20.3006 40.6065 21.824 40.6065 23.6936C40.6065 25.5633 42.1301 27.0867 44 27.0867C45.8699 27.0867 47.3935 25.5748 47.3935 23.6936ZM47.3935 43.9942C47.3935 42.1246 45.8699 40.6012 44 40.6012C42.1301 40.6012 40.6065 42.1246 40.6065 43.9942C40.6065 45.8639 42.1301 47.3873 44 47.3873C45.8699 47.3873 47.3935 45.8754 47.3935 43.9942ZM47.3935 64.2948C47.3935 62.4252 45.8699 60.9018 44 60.9018C42.1301 60.9018 40.6065 62.4252 40.6065 64.2948C40.6065 66.1645 42.1301 67.6879 44 67.6879C45.8699 67.6879 47.3935 66.176 47.3935 64.2948ZM47.3935 84.607C47.3935 82.7373 45.8699 81.2139 44 81.2139C42.1301 81.2139 40.6065 82.7373 40.6065 84.607C40.6065 86.4766 42.1301 88 44 88C45.8699 88 47.3935 86.4766 47.3935 84.607ZM27.0902 3.39304C27.0902 1.5234 25.5666 0 23.6967 0C21.8269 0 20.3033 1.5234 20.3033 3.39304C20.3033 5.26268 21.8269 6.7861 23.6967 6.7861C25.5666 6.7861 27.0902 5.26268 27.0902 3.39304ZM27.0902 23.6936C27.0902 21.824 25.5666 20.3006 23.6967 20.3006C21.8269 20.3006 20.3033 21.824 20.3033 23.6936C20.3033 25.5633 21.8269 27.0867 23.6967 27.0867C25.5666 27.0867 27.0902 25.5748 27.0902 23.6936ZM27.0902 43.9942C27.0902 42.1246 25.5666 40.6012 23.6967 40.6012C21.8269 40.6012 20.3033 42.1246 20.3033 43.9942C20.3033 45.8639 21.8269 47.3873 23.6967 47.3873C25.5666 47.3873 27.0902 45.8754 27.0902 43.9942ZM27.0902 64.2948C27.0902 62.4252 25.5666 60.9018 23.6967 60.9018C21.8269 60.9018 20.3033 62.4252 20.3033 64.2948C20.3033 66.1645 21.8269 67.6879 23.6967 67.6879C25.5666 67.6994 27.0902 66.176 27.0902 64.2948ZM27.0902 84.607C27.0902 82.7373 25.5666 81.2139 23.6967 81.2139C21.8269 81.2139 20.3033 82.7373 20.3033 84.607C20.3033 86.4766 21.8269 88 23.6967 88C25.5666 88 27.0902 86.4766 27.0902 84.607ZM6.78699 3.39304C6.78699 1.5234 5.26338 0 3.3935 0C1.52361 0 0 1.5234 0 3.39304C0 5.26268 1.52361 6.7861 3.3935 6.7861C5.26338 6.7861 6.78699 5.26268 6.78699 3.39304ZM6.78699 23.6936C6.78699 21.824 5.26338 20.3006 3.3935 20.3006C1.52361 20.3006 0 21.824 0 23.6936C0 25.5633 1.52361 27.0867 3.3935 27.0867C5.26338 27.0867 6.78699 25.5748 6.78699 23.6936ZM6.78699 43.9942C6.78699 42.1246 5.26338 40.6012 3.3935 40.6012C1.52361 40.6012 0 42.1246 0 43.9942C0 45.8639 1.52361 47.3873 3.3935 47.3873C5.26338 47.3873 6.78699 45.8754 6.78699 43.9942ZM6.78699 64.2948C6.78699 62.4252 5.26338 60.9018 3.3935 60.9018C1.52361 60.9018 0 62.4252 0 64.2948C0 66.1645 1.52361 67.6879 3.3935 67.6879C5.26338 67.6994 6.78699 66.176 6.78699 64.2948ZM6.78699 84.607C6.78699 82.7373 5.26338 81.2139 3.3935 81.2139C1.52361 81.2139 0 82.7373 0 84.607C0 86.4766 1.52361 88 3.3935 88C5.26338 88 6.78699 86.4766 6.78699 84.607Z"
                                fill="#FFC263"
                            ></path>
                        </svg>
                    </div>
                </div>
            </section>
        </main>

        <footer-main></footer-main>
    </div>
</template>


<script>
import { VueRecaptcha } from 'vue-recaptcha'

export default {
    metaInfo () {
        return {
            title: this.$store.state.translation.auth.registration.meta.title,
            meta: [
                {
                    name: 'title', 
                    content: this.$store.state.translation.auth.registration.meta.title
                },
                {
                    name: 'keywords', 
                    content: this.$store.state.translation.auth.registration.meta.keywords
                },
                {
                    name: 'description', 
                    content: this.$store.state.translation.auth.registration.meta.description
                }
            ]
        }
    },
    components: {
        VueRecaptcha
    },
    data () {
        return {
            loader_button: false,
            currency_select_open: false,

            data: {
                email: null,
                username: null,
                password: null,
                currency: {
                    id: 1, 
                    name: 'RUB',
                    language: 'ru'
                },
                recaptchav2: null,
                recaptchav3: null,
                agreement: null
            },
            errors: {
                email: false,
                username: false,
                password: false,
                currency: false,
                agreement: false
            },

            merchants: []
        }
    },
    methods: {

        async submitForm () {

            if(!this.data.email) {
                this.errors.email = this.$store.state.translation.default.field_required
                this.$toast.error(this.$store.state.translation.auth.registration.require_email)
                return
            }
            if(!this.data.username) {
                this.errors.username = this.$store.state.translation.default.field_required
                this.$toast.error(this.$store.state.translation.auth.registration.require_username)
                return
            }
            if(!this.data.password) {
                this.errors.password = this.$store.state.translation.default.field_required
                this.$toast.error(this.$store.state.translation.auth.registration.require_password)
                return
            }
            if(!this.data.currency) {
                this.errors.currency = this.$store.state.translation.default.field_required
                this.$toast.error(this.$store.state.translation.auth.registration.require_currency)
                return
            }
            if(!this.data.agreement) {
                this.errors.agreement = this.$store.state.translation.default.field_required
                this.$toast.error(this.$store.state.translation.auth.registration.require_agreement)
                return
            }

            this.loader_button = true

            this.data.recaptchav3 = await this.recaptchaV3()

            this.$axios.post('/auth/register', JSON.stringify({
                email: this.data.email,
                username: this.data.username,
                password: this.data.password,
                currency: this.data.currency.id,
                recaptchav2: this.data.recaptchav2,
                recaptchav3: this.data.recaptchav3,
                ref_id: localStorage.getItem('ref_id') || null,
                click_id: localStorage.getItem('click_id') || null
            }))
            .then((response) => {
                this.loader_button = false
                response = response.data
                switch (response.status) {
                    case "error":
                        //this.$refs.recaptcha.reset()
                        this.data.recaptchav3 = null
                        this.$toast.error(response.message)
                        break
                    case "success":

                        localStorage.setItem('token', response.token)
                            
                        this.$axios.defaults.headers.common.Authorization = 'Bearer ' + response.token

                        if(localStorage.getItem('ref_id')) {
                            localStorage.removeItem('ref_id')
                        }
                        if(localStorage.getItem('click_id')) {
                            localStorage.removeItem('click_id')
                        }

                        this.setUser(response.user)
                        
                        this.$router.push({name: 'Home'})
                        break
                    default:
                        this.$toast.error(this.$store.state.translation.default.unknown_error)
                }
            }).catch((error) => {
                this.loader_button = false
                let response = error.response.data
                if(response && 'status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                    if('field' in response) {
                        this.errors[response.field] = true
                    }
                }
            })
            
        },
        getMerchants () {
            this.$axios.post('/merchants/items')
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        for (let item of response.data) {
                            this.merchants.push({
                                name: item.currency,
                                language: item.language,
                                id: item.id
                            })

                            if (item.language == this.$store.state.lang) {
                                this.data.currency = {
                                    name: item.currency,
                                    language: item.language,
                                    id: item.id
                                }
                            }
                        }

                        this.setUser(response.user)
                        
                        break
                    default:
                        this.$toast.error(this.$store.state.translation.default.unknown_error)
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if(response && 'status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })
        },
        changeLang(lang) {
            this.$axios.post('/users/lang/change', JSON.stringify({
                lang: lang
            }))
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":

                        this.setUser(response.user)

                        this.setLang(response.language.lang)
                        this.setLanguages(response.language.languages)
                        this.setTranslation(response.translation)

                        localStorage.setItem('lang', response.language.lang)
                        this.$axios.defaults.headers.common.Lang = response.language.lang

                        break
                    default:
                        this.$toast.error(this.$store.state.translation.axios.unknown_error)
                }
            }).catch((error) => {
                let response = error.response.data
                if(response && 'status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })
        },
        changeMerchant () {
            this.getPromoTemplates(this.data.currency.id)
            this.changeLang(this.data.currency.language)
        },
        recaptchaToken (token) {
            this.data.recaptchav2 = token
            this.errors.recaptcha = null
        },
        onCaptchaExpired () {
            //this.$refs.recaptcha.reset()
            this.data.recaptchav2 = null
        },
        setUsername () {
            var username = this.data.email.split('@')
            this.data.username = username[0]
        }
    },
    beforeMount() {
        this.getMerchants()

        if(!this.$store.state.promo_templates.length) {
            this.getPromoTemplates()
        }
    },
    mounted () {
        const inputs = document.querySelectorAll('input')

        for (let i = 0; i < inputs.length; i++) {
            inputs[i].addEventListener('focusin', function(e) {
                e.target.classList.add('_form-focus')
                e.target.parentElement.classList.add('_form-focus')
            })
            inputs[i].addEventListener('focusout', function(e) {
                e.target.classList.remove('_form-focus')
                e.target.parentElement.classList.remove('_form-focus')
            })
        }
    }
}
</script>
